'use client'
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { useTranslations } from "next-intl";
import { Empty } from "antd";
import { type Blog } from "@/lib/@types/api/blog";
import { motion } from 'framer-motion';

import BlogItemDefault from "@/components/Blogs/BlogItemDefault";

const LatestNews = ({ blogList, title }: { blogList: Blog.BlogListItem[], title?: string }) => {
  const t = useTranslations()



  return (
    <div className="container py-10 ">
      <h2 className="text-5xl max-md:text-3xl font-bold text-center mb-20 max-md:mb-10">{title ? title : t('home.latestnews')}</h2>
      {!title && <p className="text-sm text-gray-500 text-center my-2 ">
        {t("blog.dec")}
      </p>}
      {blogList && blogList.length > 0 ? <Swiper
        spaceBetween={24}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }}
        className="animate__animated animate__fadeIn !pb-10 "
      >
        {blogList.map((news) => (
          <SwiperSlide key={news.blog_id} className=''>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.01 }}>
              <BlogItemDefault news={news}></BlogItemDefault>
            </motion.div>

          </SwiperSlide>
        ))}
      </Swiper> : <div><Empty /></div>}
    </div>
  );
};

export default LatestNews;
